/**
 * @fileoverview GET handler for the "/apps/:app_group_id/bot_tracking_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdBotTrackingSettings } from "./constants";
import type { GetBotTrackingSettingsResult } from "./types";
import { isGetBotTrackingSettingsResult } from "./validators";

export const getBotTrackingSettings = reactQueryFetcherAdapter(
  appsAppGroupIdBotTrackingSettings,
  (signal: AbortSignal, appGroupId: string): Promise<GetBotTrackingSettingsResult> => {
    return fetch(`/apps/${appGroupId}/bot_tracking_settings`, "GET", {}, { signal });
  },
  isGetBotTrackingSettingsResult
);
